import React from "react";

const Spinner = () => (
  <div className="text-center" id="spinner" placeholder="spinner">
    <i className="fa fa-circle-notch fa-solid fa-spin fa-2x mt-5"></i>
  </div>
);
export default Spinner;